import type { TableFilterIcon } from "../table-filter.type";

import { SearchOutlined } from "@ant-design/icons";

import { useTableFilterIconColor } from "../table-filter.hook";

const TableFilterIconSearch: TableFilterIcon = (filtered) => {
  const color = useTableFilterIconColor(filtered);

  return <SearchOutlined style={{ color }} />;
};

export default TableFilterIconSearch;
